<template>
  <div id="storage-list">
    <div class="page-toolbar bg-white shadow-sm p-3 justify-content-between align-items-center">
      <div class="d-flex justify-content-between ">
        <h4 class="m-0 ">
          FTP Storage List
        </h4>
        <b-button
          size="sm"
          class="ml-1 mr-3"
          @click="onAddNewStorageClick"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
          Add new storage
        </b-button>
      </div>
    </div>

    <content-spinner :show="loading" />

    <div
      v-if="!loading"
      class="inner-content p-3"
    >
      <complex-table-view
        :is-file-manipulation-controller="true"
        :small="true"
        :fields="fields"
        :items="items"
        :total-rows="items.length"
        :modal-name="`storage-list-view`"
        :action-buttons="actionButtons"
        @on-delete="onDeleteClick"
        @on-edit="onEditClick"
        @filter="onFilter"
      />
    </div>

    <add-edit-storage-modal />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ComplexTableView from '../../../core/components/complex-table/components/ComplexTableView';
import ContentSpinner from '../../../core/components/ContentSpinner';
import AddEditStorageModal from './components/AddEditStorageModal';
import filterMixin from '../../../core/mixins/filter.mixin';

const {mapActions, mapState} = createNamespacedHelpers('fileManipulationController');

export default {
  name: 'StorageListView',
  components: {
    AddEditStorageModal,
    ContentSpinner,
    ComplexTableView,
  },
  mixins: [filterMixin],
  data() {
    return {
      loading: false,
      fields: [
        {
          key: 'name',
          name: 'name',
          dataTypeName: 'text',
          label: 'Name',
        },
      ],
      actionButtons: {
        delete: true,
      },
      items: [],
    };
  },
  watch: {
    ['ftpStorageList']() {
      this.items = [...this.ftpStorageList];
    },
  },
  computed: {
    ...mapState({
      ftpStorageList: state => state.ftpStorageList,
    }),
  },
  methods: {
    ...mapActions([
      'getFtpStorageList',
      'deleteStorage',
      'showAddEditModal',
    ]),
    onAddNewStorageClick() {
      this.showAddEditModal();
    },
    onEditClick(item) {
      this.showAddEditModal(item);
    },
    async onDeleteClick(index) {
      const confirmed = await this.$confirm('Deleting Record...', 'You are deleting record. Are you sure you want to continue?');

      if (confirmed) {
        const storage = this.items[index];
        const {success, body} = await this.deleteStorage(storage);
        if (success) {
          this.$toasted.success('Storage deleted successfully', {
            duration: TOASTER_DURATION,
          });
        } else {
          this.$toasted.error(body.ErrorMessage, {
            duration: TOASTER_DURATION,
          });
        }
      }
    },
    onFilter(filters) {
      const filter = filters.filter || filters;
      this.items = this.ftpStorageList.filter(item => {
        for (const filterFieldName in filter) {
          if (!filter.hasOwnProperty(filterFieldName)) {
            continue;
          }
          const field = this.fields.find((f) => f.name === filterFieldName);
          if (field.dataTypeName === this.fieldValues.text && !this.textFilter(filter[filterFieldName], item[filterFieldName])) {
            return false;
          }
        }
        return true;
      });
    },
    async getData() {
      await this.getFtpStorageList();
    },
    prepareData() {
      this.items = [...this.ftpStorageList];
    },
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.prepareData();
    this.loading = false;
  },
};
</script>

<style lang="scss">
#storage-list {

  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .action-th {
    width: 100px;
  }

  th.th-errors {
    min-width: 200px;
  }

  .inner-content {
    overflow: auto;
    flex: 1;
  }

  .card-body {
    padding: 0;
  }

  .table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 24px;
    overflow: hidden;
    justify-content: flex-start;
  }

  tbody {
    tr:hover {
      cursor: pointer;
      background-color: #d0d0d0;
    }
  }

}
</style>